// extracted by mini-css-extract-plugin
export var standaloneTable = "_fi-0";
export var standaloneTableWithBodyFill = "_fi-1";
export var withExtraHeader = "_fi-2";